import React, {useState, useEffect} from 'react'
import fire from './fire'
import Login from "./login"
import Home from './Home';
import Admin from './Admin';
import './App.css';
import EditQuestion from './editQuestion'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import Question from './questions';
import Compete from './compete'
import SolveQuestion from './QuestionPage'
import Leaderboard from './leaderboard'
import Leaderboardend from './leaderboardend'
import Leaderboardadmin from './leaderboardadmin'
import Questions from './QuestionsListPage'
import ResetPassword from './resetPassowrd'
function App() {
  const [user, setUser] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [hasAccount, setHasAccount] = useState('');
  const [admin, setAdmin] = useState(false);
  // const [loader , setLoader] = useState(false)
  const clearInputs = () =>{
    setEmail("")
    setPassword("")
  }
  
  const clearErrors =() =>{
    setEmailError('')
    setPasswordError('')
  }
  const handleLogin = () =>{
    clearErrors()
    fire.auth().signInWithEmailAndPassword(email,password)
    .catch(err =>{
      switch(err.code){
        case "auth/invalid-email":
        case "auth/user-disabled":
        case "auth/user-not-found":
          setEmailError(err.message);
          break;
        case "auth/wrong-password":
          setPasswordError(err.message);
          break;
        default:
          setEmailError("Somthing went wrong");

      }
    })
  }

  
  const handleSignUp = async() =>{
    clearErrors()
    const sEmails = email.split("@")
    var use
    var domain
    if(sEmails[0]){
      use=sEmails[0].replace(/\./g,'"dot"')
    }
    else{
      use = ""
    }
    if(sEmails[1]){
      domain=sEmails[1].replace(/\./g,'"dot"')

    }
    else{
      domain = ""
    }
    var Email = ""
    Email = Email.concat(use,"@",domain) 
    Email = Email.toLowerCase()   
    
    
    await fetch(`https://codezap-e156b.firebaseio.com/participants/${Email}.json`,{
      method:'PATCH',
      headers:{
          'Content-Type':'application/json'
      },
      body:JSON.stringify({
        "Score":"",
        "Submission":""
      })
    })

    await fire.auth().createUserWithEmailAndPassword(email,password)
    .catch(async(err) =>{
      await fetch(`https://codezap-e156b.firebaseio.com/participants/${Email}.json`,{
        method:"DELETE"
      })
      
      switch(err.code){
        case "auth/email-already-in-use":
        case "auth/invalid-email":
          setEmailError(err.message);
          break;
        case "auth/weak-password":
          setPasswordError(err.message);
          break;
        default:
          setEmailError("Somthing went wrong");

      }
    })
    
  }

  const handleLogout = () =>{
    fire.auth().signOut();
  }

  const authListner = () =>{
    // setLoader(true)
    fire.auth().onAuthStateChanged(async(user) =>{
      
      if(user){
        clearInputs()
        setUser(user)
        // const response23 = await fetch('https://codezap-e156b.firebaseio.com/admin.json')
        // const resData = await response23.json()

        var sEmails =user.email.split("@") 
        var  use=sEmails[0].replace(/\./g,'"dot"')
        var domain=sEmails[1].replace(/\./g,'"dot"')
        var Email = ""
        Email = Email.concat(use,"@",domain) 
        Email = Email.toLowerCase()
        // var arr = Object.keys(resData)
        if(Email ===  "apnik\"dot\"jain2018@vitstudent\"dot\"ac\"dot\"in"){
          setAdmin(true)
        }
        
        
      }
      else{
        setUser("")
        setAdmin(false)
      }
      
    })
    // setLoader(false)
  }


  useEffect(() =>{
    authListner();
  },[])
  return (
    <div className="App">
    {
      
      user ? (
        admin ? 
        <Router>
          <Switch>
          <Route path = "/" exact component = {() =><Admin handleLogout = {handleLogout}/>}/>
          <Route path = "/leaderboardadmin" component = {Leaderboardadmin }/>
          <Route path = "/editQuestion" component = {EditQuestion }/>
          <Route path = "/contests" component = {Questions }/>
          <Route path = "/ResetPassword" component = {ResetPassword}/>
          </Switch>
        </Router>
          :
        
        <Router>
          
          <Switch>
            <Route path = "/" exact component = {() =><Home handleLogout = {handleLogout}/>}/>
            <Route path = "/question" component = {() =><Question handleLogout = {handleLogout}/>}/>
            <Route path = "/compete" component = {Compete}/>
            <Route path = "/contest" component = {Question }/>
            <Route path = "/solvequestion" component = {SolveQuestion }/>
            <Route path = "/leaderboard" component = {Leaderboard }/>
            <Route path = "/Leaderboardend" component = {Leaderboardend }/>
            <Route path = "/ResetPassword" component = {ResetPassword}/>
          </Switch>
        </Router>)
      :(
        
          <Login 
          email = {email} 
          setEmail = {setEmail} 
          passowrd = {password} 
          setPassword = {setPassword }
          handleLogin = {handleLogin}
          handleSignUp = {handleSignUp}
          hasAccount = {hasAccount}
          setHasAccount = {setHasAccount}
          emailError = {emailError}
          passwordError = {passwordError}

          />  
      )
    }
      
    
    </div>
  );
}


export default App;
